import {
  Box,
  Flex,
  Text,
  Spinner,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useCallback, useEffect, useState } from "react";

import { Header } from "../../../components/Header";
import { Sidebar } from "../../../components/Sidebar";
import { Schedule, useSchedules } from "../../../services/hooks/useSchedules";
import ContentBase from "../../../components/ContentBase";
import MainBase from "../../../components/MainBase";
import MainActions from "../../../components/MainActions";
import { MainTable } from "../../../components/MainTable";
import { Column } from "react-table";
import { RemoveAccent } from "../../../utils/RemoveAccent";

export function SchedulesList() {
  const [searchField, setSearchField] = useState('');
  const [allSchedules, setAllSchedules] = useState<Schedule[]>([]);

  const { data, isLoading, isFetching, error } = useSchedules()

  const fileName = `Usuários-matriculados-${Date.now()}.csv`;
  const csvHeaders = [
    {
      label: 'Aula',
      key: 'event.title'
    },
    {
      label: 'Data de Início',
      key: 'startDateFormated'
    },
    {
      label: 'Usuário',
      key: 'user.name'
    },
    {
      label: 'E-mail',
      key: 'user.email'
    },
  ]

  useEffect(() => {
    if (data) {
      setAllSchedules(data)
    }
  }, [data])

  const handleChangeSearch = useCallback((event) => {
    setSearchField(event.target.value)
  }, [])

  const handleSearch = useCallback(() => {
    if (data) {
      if (searchField) {
        const searchFieldWithoutAccent = RemoveAccent(searchField.toLowerCase())
        const schedulesFiltered = data.filter( schedule =>
          RemoveAccent(schedule.event.title.toLowerCase()).match(searchFieldWithoutAccent)
          || RemoveAccent(schedule.user.name.toLowerCase()).match(searchFieldWithoutAccent)
        )

        setAllSchedules(schedulesFiltered)

        return
      }

      setAllSchedules(data)
    }
  }, [searchField, data])

  const handleOnPressEnter = useCallback((event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  }, [handleSearch])

  const columns: Column<Schedule>[] = [
    {
      Header: "Aula",
      //  @ts-ignore TYPE NEEDS FIXING
      accessor: "event.title",
      isSortable: true,
    },
    {
      Header: "Data de Início",
      //  @ts-ignore TYPE NEEDS FIXING
      accessor: "event.start_date",
      formattedValue: "startDateFormated",
      isSortable: true,
    },
    {
      Header: "Usuário",
      //  @ts-ignore TYPE NEEDS FIXING
      accessor: "user.name",
      isSortable: true,
    },
    {
      Header: "E-mail",
      //  @ts-ignore TYPE NEEDS FIXING
      accessor: "user.email",
      isSortable: true,
    },
  ];

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  })

  return (
    <Flex direction="column" h="100vh">
      { !isWideVersion && <Header /> }

      <ContentBase>
        <Sidebar />

        <MainBase
          mainTitle="Usuários matriculados"
          isLoading={isLoading}
          isFetching={isFetching}
        >
          <MainActions
            handleChangeSearch={handleChangeSearch}
            handleOnPressEnter={handleOnPressEnter}
            handleSearch={handleSearch}
            searchPlaceHolder="Digite o título da aula ou o nome do usuário que deseja procurar..."
            csvDownload={{
              csvData: allSchedules,
              csvHeaders: csvHeaders,
              csvFileName: fileName,
            }}
          />

          <Box
            w="100%"
            h={["", null, null, "80vh"]}
          >
            { isLoading ? (
              <Flex justify="center">
                <Spinner />
              </Flex>
            ) : error ? (
              <Flex>
                <Text>Falha ao obter lista de alunos matriculados</Text>
              </Flex>
            ) : (
              <Flex
                w="100%"
                h="100%"
                direction="column"
                justifyContent="space-between"
              >
                <MainTable
                  columns={columns}
                  data={allSchedules}
                />
              </Flex>
            )}
          </Box>
        </MainBase>
      </ContentBase>
    </Flex>
  );
}
